import { render, staticRenderFns } from "./main-layout.component.vue?vue&type=template&id=50051e56"
import script from "./main-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./main-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./main-layout.component.vue?vue&type=style&index=0&id=50051e56&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50051e56')) {
      api.createRecord('50051e56', component.options)
    } else {
      api.reload('50051e56', component.options)
    }
    module.hot.accept("./main-layout.component.vue?vue&type=template&id=50051e56", function () {
      api.rerender('50051e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/main-layout/main-layout.component.vue"
export default component.exports